<template>
  <!-- 打印页 -->
  <div class="print-page">
    <div class="btn-list">
      <el-button @click="switchPrint">返回</el-button>
      <el-button v-print="'#print'">打印</el-button>
    </div>
    <div class="print-w">
      <div class="print-c-w" id="print">
        <div class="print-c-t">
          <p> </p>
          <h3> </h3>
          <h1>（{{ detailForm.schoolorgname }}）</h1>
          <h1>会议纪要</h1>
          <div class="print-table-w">
            <table border="1" width="100%" cellpadding="0" cellspacing="0" text-align="center">
              <tr>
                <td class="td-style">会议名称</td>
                <td class="td-style" colspan="3">{{ detailForm.title }}</td>
              </tr>

              <tr>
                <td class="td-style">主题词</td>
                <td class="td-style" colspan="3">{{ detailForm.terms }}</td>
              </tr>

              <tr>
                <td class="td-style">会议时间</td>
                <td class="td-style5">{{ detailForm.meetingtime }}</td>
                <td class="td-style">会议地点</td>
                <td class="td-style5">{{ detailForm.address }}</td>
              </tr>

              <tr>
                <td class="td-style">主持人</td>
                <td class="td-style">{{ detailForm.hostusername }}</td>
                <td class="td-style">记录人</td>
                <td class="td-style">{{ detailForm.insertusername }}</td>
              </tr>

              <tr>
                <td class="td-style">参会人员</td>
                <td class="td-style" colspan="3">{{ detailForm.participants }}</td>
              </tr>

              <tr>
                <td class="td-style2" colspan="4">会议主要内容</td>
              </tr>

              <tr>
                <td class="td-style3" colspan="4">{{detailForm.content}}</td>
              </tr>

              <tr>
                <td class="td-style2" colspan="4">会议决议</td>
              </tr>

              <tr>
                <td class="td-style33" colspan="4">{{detailForm.resolution}}</td>
              </tr>

              <tr>
                <td style="font-size:18px;">参会人员签名<br></br>
                  （单位盖章）</td>
                <td colspan="3" class="td-style4">（单位名称盖章）</td>
              </tr>

              <tr>
                <td class="td-style">审核人批注</td>
                <td class="td-style" colspan="3"></td>
              </tr>

              <tr>
                <td class="td-style">抄送</td>
                <td colspan="3" style="font-size:18px;">（{{detailForm.approveusername}}）办公室、行政后勤中心（存档）、王祝安办公室</td>
              </tr>


            </table>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
import { myRequest } from "@/request/index";

export default {
  data() {
    return {
      detailForm: {}, //表单

      books: [], //所有书本
    };
  },

  props: {
    id: {
      default: Number,
    },
    printUrl: String,
    resKey: String,
  },

  created() {
    this.getDataDetail();
  },
  methods: {
    switchPrint() {
      this.$emit("switchPrint", false);
    },
    //数据详情 api
    getDataDetail() {
      myRequest({
        url: this.printUrl,
        data: {
          id: this.id,
        },
      }).then((res) => {
        if (res.status === 200) {
          this.detailForm = res.data.data[this.resKey];
          this.filterFiled(this.detailForm);
        }
      });
    },

    //筛选大于0的字段
    filterFiled(obj) {
      for (var key in obj) {
        if (typeof obj[key] === "number" && obj[key] > 0) {
          this.books.push(obj[key]);
        }
      }
    },
  },
};
</script>


<style scoped lang="scss">
.Btn {
  padding: 10px;
  & > button {
    margin: 5px;
  }
}
.print-page {
  overflow-y: auto;
  height: calc(100vh);
  background-color: rgb(185, 200, 177);
}
.print-w {
  padding: 5% 30%;
}
.print-c-w {
  position: relative;
  width: 90%;
  padding: 0 5% 2% 5%;
  background-color: #fff;
}

.print-c-t > h1 {
  text-align: center;
  font-size:26px;
}

.level-w > div {
  width: 50%;
  float: left;
  margin: 0 0 10px 0;
}
.print-c-b {
  margin: 5% 0 0 0;
}
.print-c-b,
.print-c-t {
  overflow: auto;
}

.td-style {
  padding: 0 !important;
  border: 1px solid black;//边框
  border-bottom: 1px solid;
  height: 45px;
  text-align: center;
  font-size:18px;
}

.td-style2{
  text-align: center;
  height: 45px;
  font-size:18px;
}

.td-style3{
  height: 260px;
  font-size:15px;
}

.td-style33{
  height: 140px;
  font-size:15px;
}

.td-style4{
  //height: 100px;
  text-align: right;
  vertical-align: bottom;
  font-size:18px;
}

//会议时间、会议地点
.td-style5{
  text-align: center;
  width:230px;
  font-size:18px;
}

.print-table-w {
  & > table {
    & > tr:last-child {
      td {
        border-bottom: 0;
      }
    }
  }
}
</style>
